import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import {faPen, faTrashCan} from "@fortawesome/pro-light-svg-icons";
import {useMutation, useQueryClient} from "react-query";
import { useState} from "react";
import PlayIcon from "../../../../assets/createEnvAssets/PlayIcon";
import DocsIcon from "../../../../assets/createEnvAssets/DocsIcon";
import {blueprints, createNewBlueprint} from "../../../../../utils/const/query-key";
import {useNavigate} from "react-router-dom";
import apiService from "../../../../../api/apiService";
import {MessageModalHelper} from "../../../../common/MessageHelper";
import MessageModal from "../../../../common/MessageModal";

const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  color: var(--color-table-filter);

  .shared_icon {
    width: 17px;
  }
`;
const Icons = styled.span`
    flex: 1;
    justify-content: end;
    display: flex;
    align-items: flex-start;
    white-space: nowrap;
`
const Icon = styled.span`
    display: flex;
    white-space: nowrap;
    padding-left:4px;
    &:hover {
    color: var(--color-brand-pink-primary);
    var(--color-brand-pink-primary);
    }
`

const useDeleteBp = ( bp, setOpen, setModal, open, goBack ) => {

    return useMutation(createNewBlueprint + "-delete-" + bp.id,
        (bp) => apiService.createBlueprint(bp),
        {
            onSuccess: (status) => {
                MessageModalHelper(setModal,"delete", status, goBack);
                setOpen(true);
            },
        }
    );
}
const RowIconsCell = ({bp}) => {
    const [open, setOpen] = useState(false);
    const [modal, setModal] = useState({});
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const goBack = () => {
        queryClient.invalidateQueries({queryKey: blueprints}).then()
        navigate("/admin")
    };
    const {mutate: deleteBlueprint} = useDeleteBp(bp, setOpen, setModal, open, goBack);

    const deleteBp=()=>{
        let deleteBp = {...bp, "isDeleted": true};
        deleteBlueprint({...deleteBp});
    }
    const clickDelete = () => {
        setModal({
            message: "Are you sure you want to delete this blueprint? ",
            submit: "Yes",
            cancel:true,
            fnOnSubmit:deleteBp,
            fnOnCancel:goBack
        })
        setOpen(true)
    }

    return (
        <Wrapper>  {open && <MessageModal modal={modal} open={open} setOpen={setOpen}/>}
            <Icons className={"icons-blueprint"}>
                <Icons>
                    {(bp?.videoLink !== "" && bp?.videoLink !== null) &&
                        <Icon className={"icon"}>
                            <a className={"icon"} href={bp?.videoLink} target="_blank" rel="noreferrer" id={"video_link"} title={"Video Link"}>
                                <PlayIcon className={"icon"}/>
                            </a>
                            <span className={"separator"}>|</span>
                        </Icon>
                    }
                    <Icon>
                        <a href={bp?.userGuideLink} target="_blank" rel="noreferrer" id={"user_guide_link"} title={"User Guide Link"}>
                            <DocsIcon/>
                        </a>
                    </Icon>
                    <span className={"separator"}>|</span>
                    <Icon onClick={() => {
                        navigate("/admin/edit-blueprint/" + bp?.id)
                    }}>
                        <span id={"edit"} title={"Edit Blueprint"}>
                            <FontAwesomeIcon icon={faPen}/>
                        </span>
                    </Icon>
                    <span className={"separator"}>|</span>
                    <Icon onClick={clickDelete}>
                        <span id={"delete"} title={"Delete Blueprint"}>
                            <FontAwesomeIcon icon={faTrashCan}/>
                        </span>
                    </Icon>
                </Icons>
            </Icons>
        </Wrapper>
    );
};

export default RowIconsCell;
